import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back_dark",
  "use": "icon-back_dark-usage",
  "viewBox": "0 0 18 34",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 34\" id=\"icon-back_dark\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-9-1.4h36v36H-9z\" /><path d=\"M0 16.6 14.863.403a1 1 0 0 1 1.473 0L17.38 1.54a1 1 0 0 1 0 1.352L4.8 16.6l12.58 13.708a1 1 0 0 1 0 1.352l-1.044 1.137a1 1 0 0 1-1.473 0L0 16.6Z\" fill=\"#333\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol